import React, { useState } from "react";
import "../styles/table.css";
import { Button } from "@mui/material";
import ExportToExcelBTN from "./ExportToExcelBTN";
import downloadExcel from "./DownloadExcel";
import { useUser } from "../Contexts/UserContext";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const Table2 = ({ data, itemsPerPage }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [modalImage, setModalImage] = useState(null);
  const { user } = useUser();
  const { ClientId, CompCode } = user;

  const handleViewImage = (imageUrl) => {
    setModalImage(imageUrl);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pageCount = Math.ceil(data.length / itemsPerPage);
  const paginatedData = data.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const fetchAllMaterials = async () => {
    //fetch and download in excel
    const rawData = await fetch(
      `${API_URL}/facility/GetPivotReport/${ClientId}`
    ).then((res) => res.json());
    console.log(rawData);
    downloadExcel(
      rawData.data.length > 0 ? rawData.data : [],
      "materials_ordered.xlsx"
    );
  };
  return (
    <>
      <ExportToExcelBTN data={data} />
      {/* <Button onClick={fetchAllMaterials}>Materials</Button> */}
      <table className="table">
        <thead>
          <tr>
            <th>Branch</th>
            <th>Unit Code</th>
            <th>Unit Name</th>
            <th>EmpCode</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={index}>
              <td>{item.BranchName}</td>
              <td>{item.UnitCode}</td>
              <td>{item.UnitName}</td>
              <td>{item.empCode}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        {[...Array(pageCount)].map((_, i) => (
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            className={currentPage === i ? "active" : ""}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {modalImage && (
        <div className="modal" onClick={() => setModalImage(null)}>
          <span className="close">&times;</span>
          <img className="modal-content" src={modalImage} alt="Modal" />
        </div>
      )}
    </>
  );
};

export default Table2;
